import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../actions/slack";
import styled from "styled-components";
import CallOut from "../components/CallOut";
import Loader from "../components/Loader";
import Query from "url-query-parser";
import Button from "../components/Button";

const SlackAuthMessage = styled.div`
  padding: 20px;
  color: white;
  h1 {
    font-size: 28px;
  }
  font-weight: bold;
  text-align: center;
  position: relative;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

class SlackContainer extends Component {
  componentWillMount() {
    const search = Query.search(this.props.location.search).query;
    const data = Query.stringify({
      code: search[1]
    });
    if (data) {
      this.props.authSlack(data);
    } else {
      this.props.noSlackCode();
    }
  }

  renderMessage() {
    const { slack } = this.props;
    if (slack.authenticating) {
      return <Loader loading={true} />;
    }
    if (slack.authenticated) {
      return (
        <div>
          <h1>Mint, you now have Geordify on Slack</h1>
          <Button onClick={() => this.props.history.push("/")}>
            See more from Geordify
          </Button>
        </div>
      );
    }
    if (slack.hasError) {
      return <h1>Ah man, Slack is ganning akka, sorry marra</h1>;
    }
    if (!slack.hasCode) {
      return (
        <h1>There is nee auth code man, gan back to Slack and try agyen</h1>
      );
    }
  }
  render() {
    return (
      <div>
        <SlackAuthMessage>
          {this.renderMessage()}
        </SlackAuthMessage>
        <CallOut />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  slack: state.slack
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SlackContainer);



// WEBPACK FOOTER //
// ./src/containers/SlackContainer.js